import { useContext } from 'react';
import PermissionContext from 'src/contexts/PermissionContext';

const usePermission = () => useContext(PermissionContext);

export default usePermission;
